import React, { useContext } from "react"
import { AdminContext } from "~/contexts/AdminContext"
import useBreakpoint from "~/hooks/useBreakpoint"
import Spinner from "~/components/ui/Spinner"
import SitesCardList from "~/components/Admin/Reports/ReportsSites/SitesCardList"
import SitesTable from "~/components/Admin/Reports/ReportsSites/SitesTable"
import SitesSummarySection from "~/components/Admin/Reports/ReportsSites/SitesSummarySection"

export type iSiteReport = {
  site_name: string
  booked: number
  blocked: number
  avg_rate: number
  room_rate: number
  revenue: number
  available: number
  occupancy_without_blockers: string
  occupancy: string
}

export type iSiteSummaryReport = {
  avg_camp_occupancy: string
  avg_site_revenue: number
}

interface ComponentProps {
  data: iSiteReport[]
  summary: iSiteSummaryReport
  isLoading: boolean
}

const ReportsSites = (props: ComponentProps) => {
  const { camp } = useContext(AdminContext)
  const isMedium = useBreakpoint("(max-width: 768px)")

  return (
    <div className="relative w-full">
      {props.isLoading && (
        <div className="z-20 absolute top-0 bg-transparent w-full h-full opacity-70 flex items-start pt-16 justify-center">
          <Spinner size={12} />
        </div>
      )}

      <div className="flex flex-col w-full" style={{ height: "calc(100vh - 255px)", minHeight: "400px" }}>
        <SitesSummarySection summary={props.summary} camp={camp} isMobile={isMedium} />

        <div
          className="overflow-auto flex-grow relative scrollbar-thin"
          style={{
            scrollbarWidth: (isMedium && "none") || "auto",
          }}
        >
          {isMedium ? <SitesCardList data={props.data} camp={camp} /> : <SitesTable data={props.data} camp={camp} />}
        </div>
      </div>
    </div>
  )
}

export default ReportsSites
